import { Roles, UserService } from '@/app/shared/services/user.service'
import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

/**
 * Réserve la consultation des non-conformités aux rôles qui y ont accès côté ProFile.
 * Le MsalGuard parent garantit déjà l'authentification ; ici on vérifie le rôle (claim coreRoles).
 *
 * Le gestionnaire de stock y a droit, mais avec un périmètre RESTREINT : ProFile ne lui remonte que
 * les non-conformités rattachables à une commande ou à un retour de SES lieux de stock, celles sans
 * lien déductible étant masquées. Le filtrage est entièrement porté par le backend — cette garde
 * n'ouvre que la porte, elle ne décide pas de ce qui est visible derrière.
 *
 * GlobalReader et GlobalAdmin voient l'intégralité des non-conformités.
 *
 * Anciennement globalReaderGuard : renommé le jour où le gestionnaire de stock a été ajouté, le nom
 * ne décrivant plus la règle. Cette garde n'a jamais servi qu'à cette route.
 */
export const nonConformityGuard: CanActivateFn = () => {
  const user = inject(UserService)
  const router = inject(Router)

  if (user.hasRole(Roles.GlobalReader) || user.hasRole(Roles.GlobalAdmin) || user.hasRole(Roles.StockManager) || user.hasRole(Roles.CPO)) return true

  return router.createUrlTree(['/requisitions'])
}
